import { useCallback, useEffect, useRef, useState } from 'react';
import { useAppContext } from '../context/AppContext';
import { useNavigate } from 'react-router-dom';
import { useTheme } from '../context/ThemeContext';
import Blockies from 'react-blockies';
import { BiDirectionIcon, ArrowDownMdIcon, DisconnectIcon } from './SVGIcons';
import ConnectWalletBtn from './ConnectWalletBtn';
import { useEVMContext } from '../context/EVMContext';
import { formatAddress } from '../utils';

export const WalletConnect = ({ mobile = false }: { mobile?: boolean }) => {
  const { error } = useAppContext();
  const { accounts, EVMNetwork, setEVMNetwork, signer, disconnectEVMWallet } = useEVMContext();
  const dropdownRef = useRef<HTMLDivElement>(null);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const navigate = useNavigate();
  const { theme } = useTheme();

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsDropdownOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (error) {
      // toast.error(error);
      console.log(error);
    } else if (accounts.length == 0) {
      // toast.error("No accounts found. Please connect your wallet.");
      console.log("No accounts found. Please connect your wallet.");
    }
  }, [error, accounts]);

  const selectAccount = useCallback((account: string, isDepositor: boolean) => {
    if (isDepositor) {
      navigate(`/depositor/${account}`);
    } else {
      navigate(`/trader/${account}`);
    }
    setIsDropdownOpen(false);
  }, [accounts])


  if (mobile && signer) {
    return (
      <div className="flex flex-col gap-2 w-full">
        {/* <Link
          to="/profile"
          className="flex items-center gap-2 text-white py-2"
        >
          <PersonIcon fillColor="white" />
          Profile
        </Link> */}
        <div className="text-gray-400 text-xs mt-2 mb-1">Accounts</div>
        {accounts.map((account) => (
          <div key={account}>
            <button
              onClick={() => selectAccount(account, true)}
              className="flex items-center gap-2 text-white py-2 w-full text-left"
            >
              <ArrowDownMdIcon fillColor="white" />
              <div style={{ width: '20px', height: '20px', borderRadius: '50%', overflow: 'hidden', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <Blockies seed={account.toLowerCase()} size={8} scale={2} />
              </div>
              <span className="truncate">{account} Depositor Page</span>
            </button>
            <button
              onClick={() => selectAccount(account, false)}
              className="flex items-center gap-2 text-white py-2 w-full text-left"
            >
              <BiDirectionIcon fillColor="white" />
              <div style={{ width: '20px', height: '20px', borderRadius: '50%', overflow: 'hidden', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <Blockies seed={account.toLowerCase()} size={8} scale={2} />
              </div>
              <span className="truncate">{account} Trader Page</span>
            </button>
          </div>
        ))}
        <button
          onClick={disconnectEVMWallet}
          className="flex items-center gap-2 text-white py-2 mt-2 w-full text-left"
        >
          <DisconnectIcon fillColor="white" />
          Disconnect Wallet
        </button>
      </div>
    );
  }

  const switchNetwork = () => {
    const next = EVMNetwork === 'mainnet' ? 'testnet' : 'mainnet';
    setEVMNetwork(next);
  }

  return (
    <div className="p-2 md:p-4 flex items-center gap-2 md:gap-4">
      {/* <div className="flex items-center">
        <span className="mr-2 text-xs font-medium text-gray-600 dark:text-gray-300">Testnet</span>
        <label className="relative inline-flex items-center cursor-pointer">
          <input
            type="checkbox"
            checked={EVMNetwork === 'mainnet'}
            onChange={switchNetwork}
            className="sr-only peer"
          />
          <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-2 peer-focus:ring-blue-500 dark:bg-gray-700 rounded-full peer peer-checked:bg-blue-600 transition-colors"></div>
          <div className="absolute left-1 top-1 bg-white border border-gray-300 dark:border-gray-600 rounded-full w-4 h-4 transition-transform peer-checked:translate-x-5"></div>
        </label>
        <span className="ml-2 text-xs font-medium text-gray-600 dark:text-gray-300">Mainnet</span>
      </div> */}
      {!signer ? (
        <ConnectWalletBtn />
      ) : (
        <div className="relative" ref={dropdownRef}>
          <button
            className="bg-[#F2F2F2] dark:bg-[#262626] text-black dark:text-white px-3 md:px-4 py-2 rounded-[100px] text-xs md:text-sm font-medium hover:bg-blue-50 transition-colors duration-200 flex items-center gap-2"
            onClick={() => setIsDropdownOpen(!isDropdownOpen)}
          >
            <div style={{ width: '20px', height: '20px', borderRadius: '50%', overflow: 'hidden', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <Blockies seed={accounts[0] || ''} size={10} scale={2} />
            </div>
            <span className="hidden sm:inline">{formatAddress(accounts[0])}</span>
            <span className="text-xs">▼</span>
          </button>
          {isDropdownOpen && (
            <div className="flex flex-col gap-[12px] absolute text-black dark:text-white right-0 mt-2 w-64 md:w-72 bg-white dark:bg-[#262626] rounded-[12px] shadow-[0_0_10px_0_rgba(0,0,0,0.1)] dark:shadow-[0_0_10px_0_rgba(255,255,255,0.1)] p-[12px] z-50 max-h-96 overflow-y-auto">
              {/* <Link
                to="/profile"
                className="block py-2 px-2 text-sm hover:bg-gray-200 dark:hover:bg-gray-700 h-[40px] hover:rounded-[8px] flex items-center gap-2"
                onClick={() => setIsDropdownOpen(false)}
              >
                <PersonIcon fillColor={theme === 'dark' ? 'white' : 'black'} />
                Profile
              </Link>
              <div className="border-t my-1 dark:border-white/10 my-2" /> */}
              {accounts.map((account) => (
                <div key={account} className='flex flex-col gap-[12px]'>
                  <p className="text-sm text-black/50 dark:text-white/50 ">
                    {formatAddress(account)}
                  </p>
                  <button
                    onClick={() => selectAccount(account, true)}
                    className="w-full text-left p-[8px] text-sm hover:bg-[#F2F2F2] dark:hover:bg-white/10 flex gap-[12px] h-[40px] hover:rounded-[8px] items-center"
                  >
                    <ArrowDownMdIcon fillColor={theme === 'dark' ? 'white' : 'black'} />
                    <div className='flex items-center gap-1'>
                      <div style={{ width: '20px', height: '20px', borderRadius: '50%', overflow: 'hidden', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <Blockies seed={account.toLowerCase()} size={10} scale={2} />
                      </div>
                      <span className="truncate">{formatAddress(account)} Depositor Page</span>
                    </div>
                  </button>
                  <button
                    onClick={() => selectAccount(account, false)}
                    className="w-full text-left p-[8px] text-sm hover:bg-[#F2F2F2] dark:hover:bg-white/10 flex gap-[12px] h-[40px] hover:rounded-[8px] items-center"
                  >
                    <BiDirectionIcon fillColor={theme === 'dark' ? 'white' : 'black'} />
                    <div className='flex items-center gap-1'>
                      <div style={{ width: '20px', height: '20px', borderRadius: '50%', overflow: 'hidden', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <Blockies seed={account.toLowerCase()} size={10} scale={2} />
                      </div>
                      <span className="truncate">{formatAddress(account)} Trader Page</span>
                    </div>
                  </button>
                </div>
              ))}
              <div className="w-full h-[1px] bg-[rgba(0,0,0,0.06)] dark:bg-white/10" />
              <button
                onClick={disconnectEVMWallet}
                className="w-full text-left p-[8px] text-sm hover:bg-[#F2F2F2] dark:hover:bg-white/10 flex gap-[12px] h-[40px] hover:rounded-[8px] items-center"
              >
                <DisconnectIcon fillColor={theme === 'dark' ? 'white' : 'black'} />
                Disconnect Wallet
              </button>
            </div>
          )}
        </div>
      )}
    </div>
  );
};
